import React from "react";

import CostumerForm from "../CostumerForm";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";

export default function CustomerAccounts() {
    return (
        <React.Fragment>
            <div
                style={{
                    display: "grid",
                    minHeight: "600px",
                    gridTemplateColumns: "auto",
                    gridColumnGap: "4px",
                    border: 0,
                    overflowY: "scroll",
                    maxHeight: "621px",
                }}
            >
                <CostumerForm isPrincipal={true} />
            </div>
        </React.Fragment>
    );
}
